import type { DocumentRecipientRevision } from '@getaccept/lib-shared-new/src/types/document-revision';
import { DocumentRevisionStatus } from '@getaccept/lib-shared-new/src/types/document-revision';

export class RevisionHelper {
  static getLatestSealedRevision(
    revisions?: DocumentRecipientRevision[]
  ): DocumentRecipientRevision {
    const sealedRevisions = revisions?.filter(
      revision => revision.status === DocumentRevisionStatus.Sealed
    );
    if (sealedRevisions && sealedRevisions.length) {
      return sealedRevisions[sealedRevisions.length - 1];
    }
    return null;
  }
}
